import React from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getImageStylesAndSrc } from './helpers';
import cleanLinkSrc from '../../../../utils/xss/cleanLinkSrc';
var ImageMonoHtmlView = function (props) {
    var deviation = props.deviation, propsWidth = props.width, config = props.config;
    var calculatedProps = getImageStylesAndSrc(deviation, propsWidth, config);
    if (!calculatedProps) {
        return null;
    }
    var wrapperStyles = calculatedProps.wrapperStyles, coverThumb = calculatedProps.coverThumb, imgStyles = calculatedProps.imgStyles;
    return (React.createElement(EditorDeviationLink, { link: config.link, deviation: deviation, linkClass: getThumbGlobalClassNames(deviation) },
        React.createElement("div", { style: wrapperStyles, className: classnames('daeditor-image-mono', getThumbGlobalClassNames(deviation), props.config &&
                props.config.alignment &&
                "daeditor-align-".concat(props.config.alignment), props.settings &&
                props.settings.showMediaAlwaysSmall &&
                "daeditor-small", props.config.size === 'fullWidth'
                ? 'daeditor-full-width'
                : 'daeditor-best-fit') },
            React.createElement("img", { src: cleanLinkSrc(coverThumb.src), style: imgStyles, alt: deviation.title, loading: "lazy" }))));
};
ImageMonoHtmlView.displayName = 'ImageMonoHtmlView';
export default ImageMonoHtmlView;
//# sourceMappingURL=ImageHtml.js.map